import { z } from 'zod';
import { ApplicationActionName } from "./ApplicationAction";
var ActionBase = z.object({
  displayName: z.string()
});
export var ApplicationAvailableAction = z.discriminatedUnion('id', [ActionBase.extend({
  id: z.literal(ApplicationActionName.ADD_REQUIREMENTS)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.CANCEL)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.COMPLETE_ADMISSION)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.CANCEL_REFUND)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.COMPLETE_EVALUATION)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.COMPLETE_VISA_STEPS)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.CONFIRM_ENROLMENT_EARLY)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.CONFIRM_ENROLMENT)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.DECIDE_ACCEPTED)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.DECIDE_REJECTED)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.DECIDE_PROGRAM_CLOSED)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.DECIDE_WAITLISTED)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.EDIT_CANCEL_REASON)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.EDIT_WITHDRAW_REASON)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.FINISH_REFUND)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.RECOMMENDED_PROGRAM)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.REQUEST_DEFERRAL)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.REQUEST_TUITION_DEPOSIT_REFUND)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.STAGE_CHANGE_SUBMISSION)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.START_DEFERRAL)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.START_REFUND)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.SUBMIT_TO_SCHOOL)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.RESTART_DECISION)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.RESTART_EVALUATION)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.RESTART_SUBMISSION)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.RESTART_ADMISSION)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.RESTART_VISA_STEPS)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.UNDO_CANCEL)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.UNDO_WITHDRAW)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.WITHDRAW)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.UNDO_CONFIRM_ENROLMENT)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.UNDO_CONFIRM_ENROLMENT_EARLY)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.CHANGE_INTAKE),
  additionalInformation: z.object({
    eslIntakeUpdateAllowed: z["boolean"]().nullish(),
    startDateUpdateAllowed: z["boolean"]().nullish(),
    showAllIntakes: z["boolean"]().nullish()
  }).nullish()
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.CHANGE_PROGRAM),
  additionalInformation: z.object({
    startDateUpdateAllowed: z["boolean"]().nullish()
  }).nullish()
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.CANCEL_DEFERRAL),
  additionalInformation: z.object({
    startDateUpdateAllowed: z["boolean"]().nullish()
  }).nullish()
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.FINISH_DEFERRAL),
  additionalInformation: z.object({
    startDateUpdateAllowed: z["boolean"]().nullish()
  }).nullish()
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.COMPARE_REQUIREMENTS),
  additionalInformation: z.object({
    hasConflicts: z["boolean"]().nullish()
  }).nullish()
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.CREATE_CUSTOMER_NOTE),
  additionalInformation: z.object({
    bulkCreateAllowed: z["boolean"]().nullish(),
    emailRpAllowed: z["boolean"]().nullish(),
    createPrivateAllowed: z["boolean"]().nullish(),
    attachDocumentAllowed: z["boolean"]().nullish(),
    prefillFromTemplateAllowed: z["boolean"]().nullish(),
    editorPowerFeaturesAllowed: z["boolean"]().nullish()
  }).nullish()
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.CREATE_ADMIN_NOTE),
  additionalInformation: z.object({
    bulkCreateAllowed: z["boolean"]().nullish(),
    attachDocumentAllowed: z["boolean"]().nullish()
  }).nullish()
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.EDIT_COMMISSION)
}), ActionBase.extend({
  id: z.literal(ApplicationActionName.VIEW_COMMISSION)
})]);
export var ApplicationAvailableActionResponse = z.object({
  attributes: z.object({}).passthrough(),
  id: z.string(),
  type: z.literal('application_available_action')
});